export { default as AddIcon } from './add.svg';
export { default as ArrowDownIcon } from './arrowDown.svg';
export { default as ArrowLeftIcon } from './arrowLeft.svg';
export { default as ArrowUpIcon } from './arrowUp.svg';
export { default as CalendarIcon } from './calendar.svg';
export { default as ChevronDownIcon } from './chevronDown.svg';
export { default as ChevronDownGreyIcon } from './chevronDownGrey.svg';
export { default as ChevronLeftIcon } from './chevronLeft.svg';
export { default as ChevronRightIcon } from './chevronRight.svg';
export { default as ChevronRightDarkIcon } from './chevronRightDark.svg';
export { default as ChevronUpIcon } from './chevronUp.svg';
export { default as ChevronUpWhiteIcon } from './chevronUpWhite.svg';
export { default as CloseIcon } from './close.svg';
export { default as CloseGreyIcon } from './close-grey.svg';
export { default as DeleteIcon } from './delete.svg';
export { default as ExclamationBubble } from './exclamation-bubble.svg';
export { default as ExclamationBubbleOrange } from './exclamation-bubble-orange.svg';
export { default as GoalsIcon } from './goals.svg';
export { default as Heart } from './heart.svg';
export { default as HeartBlue } from './heart-blue.svg';
export { default as InfoIcon } from './info.svg';
export { default as InfoSolidGreyIcon } from './infoSolidGrey.svg';
export { default as InfoPrimaryIcon } from './infoPrimary.svg';
export { default as InfoErrorIcon } from './infoError.svg';
export { default as MailIcon } from './mail.svg';
export { default as PhoneIcon } from './phone.svg';
export { default as RetirementIcon } from './retirement.svg';
export { default as SearchIcon } from './search.svg';
export { default as SelfDirectedIcon } from './selfDirected.svg';
export { default as SuccessCircleIcon } from './successCircle.svg';
export { default as RepeatBlue } from './repeatBlue.svg';
export { default as RecurringDepositBlue } from './recurringDepositBlue.svg';
export { default as FilterIcon } from './filter.svg';
export { default as RiskTolerance } from './risk-tolerance.svg';
export { default as EditIcon } from './edit.svg';
export { default as TrashIcon } from './trash.svg';
export { default as RothIRAIcon } from './roth-ira.svg';
export { default as TradIRAIcon } from './trad-ira.svg';
export { default as SuccessCircleGreenIcon } from './success-circle-green.svg';
export { default as ExclamationCircleIcon } from './exclamation-circle.svg';
export { default as RefreshBlue } from './refreshBlue.svg';
//FIXME: we need to use svgr instead of images with src
export { default as PendingBlueIcon } from './pending-blue.svg';
export { default as PendingRedIcon } from './pending-red.svg';
export { default as CheckIcon } from './check.svg';
